<template>
  <a class="button ver_orgaos">
   {{ text }}
  </a>
</template>

<script>
export default {
  name: "Button",
  props:["text"]
}
</script>

<style scoped>
/*172*/
.ver_orgaos {
  font-family: 'Montserrat Bold',serif;
  font-size: 14px;
  margin-left: 0;
  letter-spacing: 0px;
  padding: 24px 50px;
  text-transform: uppercase;
  color: white;
}



/*188*/
/*.ver_orgaos:hover {
  background-color: #B53535;
}*/

@media (min-width : 768px)
and (max-width : 1024px) {
  /*1148*/
  .ver_orgaos {
    font-size: 15px;
    margin-left: 0;
    letter-spacing: 1.2px;
    padding-top: 21px;
    padding-bottom: 21px;
    color: white;
    width: 100%;
  }
}

@media (max-width: 767px) {
  .ver_orgaos{
    font-size: 13px;
    width: 100%;
  }

  .ver_orgaos {
    padding: 20px 50px;
  }




}


</style>